// this file added by Bearer Web Developer (LimittedOrdersToastState)
import { Instance, types } from "mobx-state-tree";
export const LimittedOrdersToastState = types
    .model("LimittedOrdersToastState", {
        open: types.optional(types.boolean, false),
    })
    .actions(self => {
        return {
            setOpen(value: boolean) {
                self.open = value;
            }
        }
    }).actions(self => {
        return {
            handleOpenToast() {
                self.setOpen(true);
            },
            handleCloseToast() {
                self.setOpen(false);
            }
        }
    })
export interface ILimittedOrdersToastState extends Instance<typeof LimittedOrdersToastState> { };